import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';

import NameEdit from './NameEdit';
import DeviceDetailContainer from '../../containers/DeviceDetailContainer';

import styles from './Device.module.scss';

const Device = React.memo(({ id, index, name, isPersisted, onUpdate }) => {
  const nameEdit = useRef(null);

  const handleNameUpdate = useCallback(
    (newName) => {
      onUpdate({
        name: newName,
      });
    },
    [onUpdate],
  );

  return (
    <Draggable draggableId={`device:${id}`} index={index} isDragDisabled={!isPersisted}>
      {({ innerRef, draggableProps, dragHandleProps }) => (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <div {...draggableProps} {...dragHandleProps} ref={innerRef} className={styles.wrapper}>
          <NameEdit ref={nameEdit} defaultValue={name} onUpdate={handleNameUpdate}>
            <div className={styles.device}>
              {isPersisted ? (
                <>
                  <DeviceDetailContainer id={id} />
                </>
              ) : (
                <span className={styles.content}>
                  <DeviceDetailContainer id={id} />
                </span>
              )}
            </div>
          </NameEdit>
        </div>
      )}
    </Draggable>
  );
});

Device.propTypes = {
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  isPersisted: PropTypes.bool.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default Device;
